const ctaFilter = require('./ctaHandler');

const { filteringOptions } = window;

const prepareTag = (string) => {
  return string.replace(/\s+/g, '-').toLowerCase();
};

const populateFilters = (type) => {
  filteringOptions[type].forEach((filter) => {
    const filterHTML = `<li><input type="checkbox" id="${prepareTag(filter)}" name="${prepareTag(filter)}" value="${filter}"><label for="${prepareTag(filter)}">${filter}</label></li>`;
    $(`#onBrand__filter--${type} > ul`).append(filterHTML);
  });
};

const streamTraverse = (arr) => {
  let foundOne = false;
  arr.forEach((streamPage) => {
    if (
      $('body').hasClass(`stream-${streamPage.stream}`) ||
      $('body').hasClass(streamPage.stream)
    ) {
      foundOne = true;
    }
  });
  return foundOne;
};

const determineFilterCatergories = (arr, id) => {
  arr.forEach((streamPage) => {
    if (streamPage.stream === id || $('body').hasClass(streamPage.stream)) {
      const keys = Object.keys(streamPage).filter((key) => streamPage[key] !== false);
      keys.forEach((key) => {
        if (key !== 'stream' && key) {
          const title = key.replace(/-/g, ' ');
          const filters = `
        <fieldset id="onBrand__filter--${key}">
          <legend class="onBrand__filter--title">${title}</legend>
          <ul></ul>
        </fieldset>
        `;
          $('#onBrand__filter--form').append(filters);
          populateFilters(key);
        }
      });
    }
  });
};

const sideBarFiltering = () => {
  if (streamTraverse(window.streamFiltering)) {
    $('body').addClass('onBrand__filter');
    const pageID = $('#page-type-identifier').attr('data-collection-id');
    const sideBarHTML = `
            <form id="onBrand__filter--form"></form>
    `;
    const filterLabelsContainer = `
      <div class="onBrand__filterLabels--container"></div>
    `;
    $('.main .level-two').prepend(sideBarHTML);
    $('.description-block').append(filterLabelsContainer);
    determineFilterCatergories(window.streamFiltering, pageID);
  } else {
    $('#onBrand__filter--form').remove();
    $('#onBrand__filterLabels--container').remove();
    $('body').removeClass('onBrand__filter');
  }
};

const determineHighlightTile = () => {
  const indexOfFirstTile = 0;
  $('.tile').removeClass('highlight');
  const newHighlightTile = $('.tile:visible').get(indexOfFirstTile);
  if (newHighlightTile) {
    newHighlightTile.classList.add('highlight');
  }
};

function checkForCTA() {
  const hasCTA = document.querySelector('.tile.cta') ? true : false;
  console.log(hasCTA);
  hasCTA
  ? ctaFilter.ctaInit()
  : null;
}

const ajaxSuccess = (data, hasCTA) => {
  $(data).appendTo('#collection-items ul.clearfix:not(.social-media-icons');
  $(data).appendTo('ul.clearfix:not(.social-media-icons)');
  checkForCTA();
  determineHighlightTile();
};

const getAllTiles = () => {
  if (streamTraverse(window.streamFiltering) && !document.body.classList.contains('single-page')) {
    const collectionId = $('#page-type-identifier').attr('data-collection-id');

    const hasCTA = document.querySelector('.tile.cta') ? true : false;

    $('ul.clearfix:not(.social-media-icons) > .tile').remove();
    $.get(`/hubsFront/ajax_loadAdditionalItems/?collectionId=${collectionId}&currentPage=-1&limit=0&featuredItemCount=0&embedded=0`).success(ajaxSuccess);
  }
};

const filterTiles = (tilesToShow) => {
  const indexOfNoTiles = 0;
  const $tilesToShow = $(tilesToShow).not('#onBrand__filter--form');
  const $otherTiles = $('.tile:not(.cta)')
    .not($tilesToShow)
    .not('#onBrand__filter--form');

  $otherTiles.hide();
  $tilesToShow.show();

  ctaFilter.ctaInit();
    
  if ($tilesToShow.length > indexOfNoTiles) {
    determineHighlightTile();
  }
};

const determineTiles = (checkedCategories) => {
  const tilesToShow = {};

  for (const category in checkedCategories) {
    const currentCategory = checkedCategories[category]; //array of tag values
    if (!tilesToShow[category]) {
      tilesToShow[category] = [];
    }

    Array.from(document.querySelectorAll('.tile')).filter((element) => {
      let passes = false;
      if (element.dataset.tags) {
        currentCategory.forEach((tag) =>
            element.dataset.tags.toLowerCase().indexOf(tag) > -1
              ? passes = true
              : null);
      }
      if (passes) {
        tilesToShow[category].push(element);
      }
      if (element.classList.contains('cta')) {
        tilesToShow[category].push(element);
      }
      return tilesToShow[category];
    });
  }
  return tilesToShow;
};

const removeUnwantedTiles = (allTileMatches, tile) => {
  let pass = true;
  const none = 0;
  for (const category in allTileMatches) {
    const currentCategory = allTileMatches[category];
    if (currentCategory.indexOf(tile) < none) {
      pass = false;
    }
  }
  return pass;
};

const initRemoveUnwantedTiles = (allTileMatches) => {
  Reflect.deleteProperty(allTileMatches, '');
  const tiles = Array.from(document.querySelectorAll('.tile'));
  const tilesToShow = tiles.filter(removeUnwantedTiles.bind(this, allTileMatches));
  filterTiles(tilesToShow);
};

const getSearchTerms = () => {
  const filters = $('#onBrand__filter--form input[type=checkbox]');

  filters.on('change', () => {
    const checkedCategories = {};

    /**
     * finds checked categories
     * @returns {checkedCategories} returns an array of check categories
     */
    function findChecked() {
      const title = $(this)
        .children('legend')
        .text();
      const checks = $(this).find('input[type=checkbox]:checked');
      checks.each(function(i, el) {
        if (!checkedCategories[title]) {
          checkedCategories[title] = [];
        }
        checkedCategories[title].push(el.value.toLowerCase());
      });
      return checkedCategories;
    }

    $('#onBrand__filter--form fieldset').each(findChecked);
    const allTileMatches = determineTiles(checkedCategories);
    initRemoveUnwantedTiles(allTileMatches);
  });
};

// module.export = customFilter;
export { sideBarFiltering };
export { getAllTiles };
export { getSearchTerms };



// WEBPACK FOOTER //
// ./custom-js/filtering.js